// import styles from './styles.module.scss';
import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { GameReportType } from '@/hooks/gameReport/useGameReportSearchParams/gameReportType.enum';
import { useModal } from '@/hooks/modals/useModal';
// import GameReportModalHeader from './Header';
import { useUserAccount } from '@/api/user/queries';
import { ModalsKey } from '@/enums/modalsKey';
import GameReportModalContent from './Content';
// import { Modal } from '@starsoft/common/components';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import useTranslation from 'next-translate/useTranslation';
import { ModalWithVersion } from '../../Modal/WithVersion';

export default function GameReportModal() {
  const { isOpen } = useModal(ModalsKey.GameReport);
  const { t } = useTranslation('game-report');
  const { type, gameId } = useGameReportSearchParams();
  const { game } = useGameReportData();
  const { user } = useUserAccount();

  return (
    <ModalWithVersion
      noPadding
      condition={
        isOpen && !!gameId && (type === GameReportType.BetGame ? !!user : true)
      }
      title={t('title', {
        game: game?.name,
      })}
      modal={ModalsKey.GameReport}
    >
      <GameReportModalContent />
    </ModalWithVersion>
  );
}
